import React from "react";
import { isArray, isEmpty } from "lodash";
import Media from "./Media";
import Panels from "./Panels";
import Meta from "../common/Meta";

/* eslint react/forbid-prop-types:0 */

function convertExternalHits(externalHits) {
  try {
    const result = [];
    const hitObject =
      typeof externalHits === "string" && externalHits?.length
        ? JSON.parse(externalHits.replace(/&quot;/g, '"'))
        : externalHits;
    // let startList = hitObject.hits.reduce((total,hit) => {total.push(hit.s); return total}, []);
    if (hitObject && isArray(hitObject.hits) && hitObject.hits.length > 0) {
      const keywords = hitObject.hits.reduce((total, hit, index) => {
        if (!isEmpty(hit.s)) {
          total.push({
            internalName: [],
            name: hit.label || `Hit ${index}`,
            score: 1,
            t: { speaker: hit.s },
          });
        }
        return total;
      }, []);
      hitObject.keywords = keywords;
      hitObject.type = "category";
      result.push(hitObject);
    }
    return result;
  } catch (error) {
    console.warn("#### External Hits: Invalid JSON: ", error);
    return [];
  }
}

class Index extends React.Component {
  state = {
    marks: [],
  };

  render() {
    const {
      parsedFromAnalytics,
      player,
      externalHits,
      startTime,
      advanceToFirstHit,
      isPCIFlagEnabled,
      showPCIFlag,
      handlePCIFlagClick,
      flagAction,
      handleMinimizePlayer,
      hidePlayer,
      transcriptLength,
      showToast
    } = this.props;
    const { mediaId } = parsedFromAnalytics;
    const convertedExternalHits = convertExternalHits(externalHits);
    return (
      <div className="player-container">
        <Meta />
        <Media
          mediaUrl={player.mediaUrl}
          analytics={parsedFromAnalytics}
          startTime={startTime}
          externalHits={convertedExternalHits}
          advanceToFirstHit={advanceToFirstHit}
        >
          <div
            style={{
              height: "100vh",
              display: "flex",
              flexDirection: "column",
              flexWrap: "nowrap",
            }}
          >
            <Panels
              transcriptLength={transcriptLength}
              parsedFromAnalytics={parsedFromAnalytics}
              player={player}
              externalHits={convertedExternalHits}
              isPCIFlagEnabled={isPCIFlagEnabled}
              showPCIFlag={showPCIFlag}
              handlePCIFlagClick={handlePCIFlagClick}
              flagAction={flagAction}
              handleMinimizePlayer={handleMinimizePlayer}
              hidePlayer={hidePlayer}
              mediaUrl={player.mediaUrl}
              showToast={showToast}
            />
          </div>
        </Media>
      </div>
    );
  }
}

export default Index;
